<template>
    <div id="app">
      <router-view></router-view>
      <FooterLoginComponent v-if="pathName == '/' || pathName == '/onesaitConfirmingProviders/index.html' || pathName == '/identificacion' ||
                                  pathName == '/primera-identificacion' || pathName == '/primera-identificacion/registro-confirming' || 
                                  pathName =='/olvido-contrasena' || pathName == '/primera-identificacion-no-cliente'"></FooterLoginComponent>
      <FooterComponent v-else></FooterComponent>
    </div>
</template>

<script>
import FooterLoginComponent from './components/FooterLoginComponent.vue'
import FooterComponent from './components/FooterComponent.vue'

export default {
  name: 'App',
  components: {
    FooterLoginComponent,
    FooterComponent
  },
  data() {
    return {
      pathName : null
    }
  },
  mounted(){
        this.pathName = location.pathname;
  },
  updated(){
      this.pathName = location.pathname;
  }
}
</script>
<style lang="less">

@import '../node_modules/vue-material/dist/vue-material.min.css';
@import '../node_modules/vue-select/dist/vue-select.css';
@import './assets/less/styles.less';
//@import '../node_modules/vue-material/dist/theme/default.css';
</style>
